import { createSvgIcon } from "@material-ui/core";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 -960 960 960",
  children: /*#__PURE__*/_jsx("path", {
    d: "M365-81q-21 0-42-2t-38-5q107-43 170-149t63-244q0-137-63-243T285-874q14-3 37-5t44-2q81 0 152.5 31.5t125.5 86Q698-709 729-636t31 155q0 82-31.5 155t-85 127.5Q590-144 518-112.5T365-81Z"
  })
}), "Brightness3Filled");